const vp = require('public/js/components/vehicle');

/* global openVehiclePicker */

const searchFilters = {};

searchFilters.handleFilterOverlayClose = function() {
	rp$('#filters-overlay').removeClass('active');
	rp$('.rp_page_linksbutton').css({ display: 'inline' });
};

searchFilters.handleVehiclePickerClick = function() {
	searchFilters.handleFilterOverlayClose();
	if (typeof openVehiclePicker === 'function') {
		openVehiclePicker({redirect: 'reload'});
	}
};

searchFilters.prepareFilters = function() {
	const $search_filters_modules = rp$('.search-filters-module');

	let $hamburger_menu_button = rp$('.rp_page_linksbutton');

	rp$('.mobile-filters-close-button').on('click', () => { searchFilters.handleFilterOverlayClose(); });

	rp$('.vehicle-picker-search-link').on('click', (e) => {
		e.preventDefault();
		searchFilters.handleVehiclePickerClick();
	});

	const filterButton = rp$('#mobile-filters-button');
	if (filterButton && filterButton.length) {
		filterButton.prependTo(filterButton.closest('.page-builder-layout-row'));

		filterButton[0].addEventListener('click', () => {
			rp$('#filters-overlay')[0].classList.add('active');

			if ($hamburger_menu_button) {
				$hamburger_menu_button.css({ display: 'none' });
			}
		});

		rp$('#mobile-filters-apply-button').on('click', () => { searchFilters.handleFilterOverlayClose(); });
		rp$('#mobile-filters-clear-button').on('click', () => { searchFilters.handleFilterOverlayClose(); });
	}

	rp$.each($search_filters_modules, function DropDownMenu_Iterator(idx, search_filters_module) {
		const $filtersForm = rp$(search_filters_module).find('.refine-search-form');
		const $makeFilter = $filtersForm.find('.refine-make-select');
		const $modelFilter = $filtersForm.find('.refine-model-select');
		const $yearFilter = $filtersForm.find('.refine-year-select');

		const getFilters = () => {
			return {
				make: $makeFilter.val(),
				model: $modelFilter.val(),
				year: $yearFilter.val(),
				search_str: $filtersForm.data('search-str'),
				page_id: $filtersForm.data('page-id'),
				page_url: $filtersForm.data('page-url')
			};
		};

		const handleFilterChange = function() {
			handleFilterApply();
		};

		const handleFilterApply = () => {
			const filters = getFilters();
			$filtersForm.trigger('changeFilters', ['', filters]);
		};

		$filtersForm.on('change', '.refine-select', (e) => {
			e.preventDefault();
			handleFilterChange();
		});
		$filtersForm.on('click', '.refine-reset', (e) => {
			e.preventDefault();
			$makeFilter.val('');
			$modelFilter.val('');
			$yearFilter.val('');
			handleFilterChange();
		});

		const $clearMobileFiltersButton = rp$('#mobile-filters-clear-button');
		if ($clearMobileFiltersButton && $clearMobileFiltersButton.length) {
			$clearMobileFiltersButton.on('click', () => {
				let filtersChanged = false;

				if (! $makeFilter.prop('disabled')) {
					$makeFilter.val('');
					filtersChanged = true;
				}
				if (! $modelFilter.prop('disabled')) {
					$modelFilter.val('');
					filtersChanged = true;
				}
				if (! $yearFilter.prop('disabled')) {
					$yearFilter.val('');
					filtersChanged = true;
				}

				if (filtersChanged) {
					handleFilterChange();
				}
			});
		}
		// $filtersForm.on('click', '.refine-submit', (e) => {
		// 	e.preventDefault();
		// 	handleFilterApply();
		// });

		/* Handle Search Response
		.*-----------------------------------------*/
		rp$(document).on('searchResults:response', (e, response={}) => {
			if (response && response.filters) {
				const yearData = vp.getDropdownContentFromData(response.filters.years);
				const makeData = vp.getDropdownContentFromData(response.filters.makes);
				const modelData = vp.getDropdownContentFromData(response.filters.models);
				vp.updateDropdownElement($yearFilter, yearData, response.year);
				vp.updateDropdownElement($makeFilter, makeData, response.make);
				vp.updateDropdownElement($modelFilter, modelData, response.model);
			}
		});

	}); // END rp$.each module
};

module.exports = searchFilters;
